// removed by extract-text-webpack-plugin
module.exports = {"container":"_3JF4T0N","wrapper":"TA65A10","image":"_3k_xFTF","name":"_2gB5Prx","optedOut":"_29dCOp8"};


//////////////////
// WEBPACK FOOTER
// ./template/components/GDPR/Option/Option.css
// module id = ./template/components/GDPR/Option/Option.css
// module chunks = client.sitechrome